import React, { useContext, useState } from "react";
import OtpVerification from "./OtpVerification";
import Loader from "./Loader";
import QuestContext from "../../../../components/QuestWrapper";
import LoginApi from "./loginApi";
import { EmailLoginProps } from "./logintypes";
import Label from "../../../../components/Modules/Label";
import { Input } from "../../../../components/Modules/Input";
import { PrimaryButton } from "../../../../components/Modules/PrimaryButton";
import { useGeneral } from "../../../../general";

const EmailLogin: React.FC<EmailLoginProps> = ({
  otpScreen,
  setOtpScreen,
  redirectURL,
  handleOtp,
  entityId,
  apiKey,
  apiSecret,
  onSubmit,
  IconColor,
  onError,
  themeManager,
  campaignId,
  campaignVariationId,
}) => {
  const [sendOTP, setSendOTP] = useState(false);
  const [email, setEmail] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [mainValidEmail, setMainValidEmail] = useState(true);
  const [showLoader, setShowLoader] = useState(false);

  const { apiType } = useContext(QuestContext.Context);
  const loginApi = new LoginApi(apiType);

  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newEmail = event.currentTarget.value;
    setEmail(newEmail);
    setIsValidEmail(validateEmail(newEmail));
  };

  const handleKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter" && event.currentTarget.value !== "") {
      setMainValidEmail(isValidEmail);
      sendOTPfunction();
    }
  };

  const sendOTPfunction = async () => {
    loginApi.trackEvent("quest_login_continue_btn_clicked", "quest_login");

    setMainValidEmail(isValidEmail);
    if (!isValidEmail || email.length === 0) {
      return;
    }

    setShowLoader(true);
    try {
      const response = await loginApi.sendOTP(email, entityId, {
        apiKey,
        apiSecret,
      });

      if (response.success) {
        setSendOTP(true);
        handleOtp(true);
      }
    } catch (error) {
      onError?.({ email, error: "Failed to send OTP" });
    } finally {
      setShowLoader(false);
    }
  };



  return (
    <div style={{ width: "100%" }}>
      {showLoader && <Loader />}

      {!sendOTP ? (
        <div className="q-email-login-ctn">
          <div>
            <Label style={themeManager.getLabelStyles()}>
              Email
            </Label>

            <Input
              iconColor={IconColor}
              style={themeManager.getInputStyles()}
              logoPosition="left"
              type="email"
              placeholder="Enter your email id"
              value={email}
              onChange={handleEmailChange}
              onKeyUp={handleKeyUp}
            />

            {!mainValidEmail && (
              <div className="q-login-p">Please enter a valid email id</div>
            )}
          </div>

          <PrimaryButton
            style={themeManager.getPrimaryButtonStyles()}
            onClick={sendOTPfunction}
          >
            Continue
          </PrimaryButton>
        </div>
      ) : (
        <OtpVerification
          otpScreen={otpScreen}
          setOtpScreen={setOtpScreen}
          sendOTP={sendOTP}
          setSendOTP={setSendOTP}
          apiKey={apiKey}
          apiSecret={apiSecret}
          redirectURL={redirectURL}
          entityId={entityId}
          email={email}
          onSubmit={onSubmit}
          onError={onError}
          themeManager={themeManager}
          campaignId={campaignId}
          campaignVariationId={campaignVariationId}
        />
      )}
    </div>
  );
};

export default EmailLogin;